/**
 * Надёжное определение доступности оборудования по данным store.equipment[id].
 *
 * Как система РЕАЛЬНО понимает, что устройство недоступно:
 *  - eq.mode === 'offline'        — операторский режим «Отключен» / устройство отключено.
 *                                   Так же трактует денежное окно (denominations2:
 *                                   `mode === 'offline' || cashbox === undefined`).
 *  - eq.controller.is_online      — сенсор «В сети» (rack-state.consts: is_online → «В сети»).
 *                                   При ПОТЕРЕ связи контроллер отдаёт ложное значение,
 *                                   при этом eq.mode может остаться прежним ('regular' и т.п.).
 *                                   Именно этот признак раньше не проверялся — из-за чего
 *                                   недоступные АПП/стойки считались «в работе».
 *  - eq / eq.mode отсутствуют     — статус ещё НЕ пришёл (частично пустой стор на старте).
 *                                   Это НЕ офлайн, а «неизвестно» — чтобы не давать ложных тревог.
 *
 * Режимы (mode-selector.consts): regular / offline / test / free / emergency /
 * blocked / app_not_work.
 */

/** статус пришёл: есть объект оборудования и у него есть mode */
export const isKnownStatus = (eq) => !!(eq && eq.mode);

/** контроллер отчитался, что он НЕ в сети (сенсор is_online = 0/false) */
const controllerOffline = (eq) => {
  const c = eq && eq.controller;
  if (!c || c.is_online === undefined || c.is_online === null) {
    return false;
  }
  return !c.is_online;
};

/**
 * Устройство недоступно (нет связи / отключено).
 * Работает и для стоек, и для АПП.
 */
export const isOffline = (eq) => {
  if (!isKnownStatus(eq)) {
    return false;
  }
  return eq.mode === 'offline' || controllerOffline(eq);
};

/**
 * Устройство в ошибке (авария/блокировка/критическое событие), но при этом на связи.
 * @param {object} eq          store.equipment[id]
 * @param {object} nodeEvents  store.events.events[id]  (объект событий узла)
 */
export const isErrored = (eq, nodeEvents) => {
  // console.log('eq', eq);
  if (!isKnownStatus(eq) || isOffline(eq)) {
    return false;
  }

  const isApp = eq.payment !== undefined || eq.cashbox !== undefined;

  const hasCritical = nodeEvents && Object.values(nodeEvents).some((e) => e.type === 'critical');
  return (isApp && eq.mode === 'emergency') || eq.mode === 'app_not_work' || !!hasCritical;
};
